export default __webpack_public_path__ + "components/weather-icon/static/daylightrain@2-4b24cfb33211dc3fc7734f03d83289b8.png";